module.exports = __webpack_public_path__ + "assets/img/home-service-price-en.4926b1aa.png";